import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import UserGroupCardItems from './UserGroupCardItems';

const UserGroupCards = ({
  canCreate,
  handleScroll,
  items,
  itemsPerRow,
  onCheckBoxClick,
  readErrors,
  readStatus,
  single,
  url,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-usergroup-cards"
    entity="usergroup"
    handleScroll={handleScroll}
    icon="users"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    url={url}
  >
    <UserGroupCardItems items={items} onCheckBoxClick={onCheckBoxClick} single={single} />
  </InfiniteScrollCards>
);

export default UserGroupCards;
